<svg [class.disabled]="disabled" fill="none" height="20" viewBox="0 0 10 20" width="10" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9 1.66667L0.999999 10.3333L9 19"
    stroke="#009DD6"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
  />
</svg>
